import Alpine from "alpinejs";

// Import SVG files as raw strings
import phpstormSvg from "../svg/phpstorm.svg?raw";
import githubCopilot from "../svg/github-copilot.svg?raw";
import cursorSvg from "../svg/cursor.svg?raw";
import claudeSvg from "../svg/claude.svg?raw";
import codexSvg from "../svg/openai-small.svg?raw";
import geminiSvg from "../svg/gemini.svg?raw";
import terminalSvg from "../svg/terminal.svg?raw";

Alpine.data("aiBoostSetup", () => ({
    selected: "phpstorm",
    tabs: [
        {
            key: "phpstorm",
            label: "PhpStorm",
            icon: "phpstorm",
            iconHtml: phpstormSvg,
            steps: [
                "Press shift twice to open the command palette",
                "Search \"MCP Settings\" and press enter",
                "Check the box next to <span>laravel-boost</span>",
                "Click 'Apply' at the bottom right",
                "If you see a green checkmark, you're ready to go!",
            ],
        },
        {
            key: "copilot",
            label: "Copilot (VS Code)",
            icon: "copilot",
            iconHtml: githubCopilot,
            steps: [
                "Open the Command Palette <span>Cmd+Shift+P</span> or <span>Ctrl+Shift+P</span>",
                'Press enter on "MCP: List Servers"',
                "Arrow to laravel-boost and press enter",
                "Choose 'Start server' and you're good to go!",
            ],
        },
        {
            key: "cursor",
            label: "Cursor",
            icon: "cursor",
            iconHtml: cursorSvg,
            steps: [
                "Open the Command Palette <span>Cmd+Shift+P</span> or <span>Ctrl+Shift+P</span>",
                'Press enter on "/open MCP Settings"',
                "Turn the toggle on for laravel-boost",
            ],
        },
        {
            key: "claude",
            label: "Claude Code",
            icon: "claude",
            iconHtml: claudeSvg,
            steps: [
                "Claude is enabled automatically, but if you find it isn't",
                "Open a shell in the project's directory",
                "Run <span>claude mcp add -s local -t stdio laravel-boost php artisan boost:mcp</span>",
            ],
        },
        {
            key: "codex",
            label: "Codex CLI",
            icon: "codex",
            iconHtml: codexSvg,
            steps: [
                "Codex support is typically enabled automatically, but if you find it isn't",
                "Open a shell in the project's directory",
                "Run <span>codex mcp add -- php artisan boost:mcp</span>",
            ],
        },
        {
            key: "gemini",
            label: "Gemini CLI",
            icon: "gemini",
            iconHtml: geminiSvg,
            steps: [
                "Gemini support is typically enabled automatically, but if you find it isn't",
                "Open a shell in the project's directory",
                "Run <span>gemini mcp add -s project -t stdio laravel-boost php artisan boost:mcp</span>",
            ],
        },
        {
            key: "manual",
            label: "Manual Install",
            icon: "terminal",
            iconHtml: terminalSvg,
            steps: [
                "Run <span>php artisan boost:mcp</span>",
            ],
        },
    ],

    handleKeyDown(event) {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") {
            return;
        }

        const currentIndex = this.tabs.findIndex((t) => t.key === this.selected);
        if (currentIndex === -1) {
            return;
        }

        const nextIndex = event.key === "ArrowRight"
            ? (currentIndex + 1) % this.tabs.length
            : (currentIndex - 1 + this.tabs.length) % this.tabs.length;

        this.selected = this.tabs[nextIndex].key;
    },

    select(key) {
        this.selected = key;
    },

    isSelected(key) {
        return this.selected === key;
    },
}));


